<template>
    <rkm-overlay>
        <Login />
    </rkm-overlay>
</template>

<script>
import Login from "@/components/administracao/autenticacao/login/Index"

export default {
    components: { Login },
}
</script>